import {
  css,
  SimpleInterpolation,
  FlattenSimpleInterpolation,
} from 'styled-components';

type MediaFnType = (
  literals: TemplateStringsArray,
  ...args: SimpleInterpolation[]
) => FlattenSimpleInterpolation;

const createMedia = (
  breakpoints: Record<string, number>,
): Record<keyof typeof breakpoints, MediaFnType> => {
  const mediaQuery = {} as Record<keyof typeof breakpoints, MediaFnType>;

  Object.keys(breakpoints).forEach((label) => {
    mediaQuery[label] = (
      literals: TemplateStringsArray,
      ...args: SimpleInterpolation[]
    ) => css`
      @media (min-width: ${breakpoints[label]}px) {
        ${css(literals, ...args)}
      }
    `;
  });

  return mediaQuery;
};

export default createMedia;
